import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import styles from "../Pages/Views/Employee/CheckInOut/checkInPage.module.less";
import {
    Body_16_Coral_Primary_Regular_16,
    Title_20_Coral_Strong_emphasis_20
} from "@UI/typography/generated/typography.tsx";
import {Gt} from "@src/i18n/Gt.tsx";
import {Button, ButtonType} from "@UI/components/controls/Button/Button.tsx";
import {LogIn} from "@UI/components/icons/LogIn.tsx";
import {Xcross} from "@UI/components/icons/Xcross.tsx";
import {Colors} from "@UI/theme/generated/Colors.ts";
import {ColorNames} from "@UI/theme/generated/ColorNames.ts";
import {Trans} from "react-i18next";
import {Link} from "react-router-dom";
import cn from "classnames";


// For a member who missed 出勤: file an event request, or at least stamp 退勤 now
export const ForgotClockInModal = ({onClose, onClockOut}: { onClose: () => void, onClockOut: () => void }) => (
    <Stack grow alignItems={"center"} justifyContent={"center"} direction={"column"} gap={24}
           className={styles.checkPopup}>
        <Stack className={styles.title} justifyContent={"center"}>
            <Title_20_Coral_Strong_emphasis_20>
                <Gt>Forgot to clock in?</Gt>
            </Title_20_Coral_Strong_emphasis_20>
        </Stack>

        <div className={styles.popupSection}>
            <Body_16_Coral_Primary_Regular_16>
                {/* Not <link>: Trans parses that HTML void tag as self-closing and leaves the anchor empty */}
                <Trans i18nKey={"You can apply for a correction <request>here</request>"}
                       components={{request: <Link to={"/requests/event"} onClick={onClose} className={styles.popupLink}/>}}/>
            </Body_16_Coral_Primary_Regular_16>
        </div>

        <Stack className={cn(styles.buttons, styles.popupSection)} direction={"column"} alignItems={"center"} gap={8}>
            {/* No trailing colon in the key: ':' is i18next's namespace separator */}
            <Body_16_Coral_Primary_Regular_16>
                <Gt>Explicit clock-out button</Gt>
            </Body_16_Coral_Primary_Regular_16>
            <Button type={ButtonType.secondary}
                    color={ColorNames.CORAL_SKY}
                    icon={<LogIn color={Colors.Obsidian_Light_0}/>}
                    onClick={() => {
                        onClose()
                        onClockOut()
                    }}
                    className={styles.popupButton}>
                <Gt>Finish work</Gt>
            </Button>
        </Stack>

        <Stack className={styles.buttons} justifyContent={"center"}>
            <Button type={ButtonType.primary} icon={<Xcross/>}
                    color={ColorNames.CORAL_MOSS}
                    onClick={onClose}
                    className={styles.popupButton}>
                <Gt>Cancel</Gt>
            </Button>
        </Stack>
    </Stack>
)
